import { render, staticRenderFns } from "./Pedidos.vue?vue&type=template&id=233f2714"
import script from "./Pedidos.vue?vue&type=script&lang=js"
export * from "./Pedidos.vue?vue&type=script&lang=js"
import style0 from "./Pedidos.vue?vue&type=style&index=0&id=233f2714&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports